const isBrowser = typeof window !== 'undefined';
const isDev = process.env.NODE_ENV === 'development';
const localHosts = new Set(['localhost', '127.0.0.1']);
const isLocalHost = isBrowser && localHosts.has(window.location.hostname);

const rewriteLocalhostApiUrl = url => {
    if (!isBrowser || !url || isLocalHost) {
        return url;
    }

    try {
        const parsed = new URL(url, window.location.origin);
        if (localHosts.has(parsed.hostname)) {
            parsed.hostname = window.location.hostname;
            return parsed.toString().replace(/\/$/, '');
        }
    } catch {
        return url;
    }

    return url;
};

const resolveApiUrl = () => {
    const fromEnv = process.env.REACT_APP_API_URL;

    if (fromEnv) {
        return isDev ? rewriteLocalhostApiUrl(fromEnv) : fromEnv;
    }

    if (isDev) {
        return '/api';
    }

    return isLocalHost ? 'http://localhost:3000/api' : '/api';
};

// En dev, /api se proxea al backend (src/setupProxy.js).
export const API_URL = resolveApiUrl();
